import script from "./Window04ProjectSepecs.vue?vue&type=script&setup=true&lang=js"
export * from "./Window04ProjectSepecs.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__